var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VContainer',{staticClass:"logout-view",attrs:{"fill-height":"","fluid":""}},[_c('VLayout',{attrs:{"justify-center":"","align-center":""}},[_c('VProgressCircular',{attrs:{"indeterminate":"","color":"grey","size":56}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }